import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import GStarEvents from "@/pages/GStarEvents";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<GStarEvents />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
